// Definição para o modal de busca de Instituições Financeiras (Bancos)
// Variação de parceiroSearch para busca de Instituições Financeiras
// Factory function - recebe idEmpresa como parâmetro

export const criarConfigBuscaParceiroInstituicaoFinanceira = (idOrganizacao) => ({
  label: 'Instituição Financeira',
  placeholder: 'Nome do Banco...',
  titulo: 'Pesquisar Instituição Financeira',
  endpointApi: 'Parceiros',
  idField: 'idParceiro',
  displayField: 'idParceiro',
  descField: 'nomeFantasia',
  camposFiltro: [
    { model: 'busca', label: 'Nome do Banco', tipo: 'text' },
    { model: 'isInstFinanceira', label: 'Financeiro', tipo: 'hidden', value: true },
    { model: 'idOrganizacao', label: 'Empresa', tipo: 'hidden', value: idOrganizacao }
  ],
  colunasGrid: [
    { header: 'Banco', dataField: 'nomeFantasia', width: '100%' }
  ]
})
